import { useEffect, useState } from "react";
import { addEditStatus, deleteStatus, getStatusList, reorderStatusList } from "../store/api/ProductionAPI";
import { Alert, Button, Col, Form, FormControl, Modal, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle, faGamepad, faStarHalfAlt, faThLarge, faThList, faTimes } from "@fortawesome/free-solid-svg-icons";
import BihamtaTable from "../../Components/BihamtaTable";
import { ArrowDownCircle, ArrowDownSquare, ArrowRepeat, ArrowUp, ArrowUpSquare, CheckLg, DashCircle, PlusCircle, PlusLg } from "react-bootstrap-icons";
import { useDispatch } from "react-redux";
import { setDialog, setErrorDialog } from "../../store/api/CommonFunctions";
import { icon } from "@fortawesome/fontawesome-svg-core";

export default function ModalBoMStatus(props) {
    const { popData, setPopData } = props;
    const { show } = popData;
    const dispatch = useDispatch();
    const [showReorderBtn, setShowReorderBtn] = useState(false);
    const [isPending, setPending] = useState(false);
    const [statusList, setStatusList] = useState();
    const [currentStatus, setCurrentStatus] = useState();
    const [submitError, setSubmitError] = useState();

    const tableCols = [
        {
            colTitle: "عنوان وضعیت", colName: "StatusTitle", showInMobile: true
        },
        {
            colTitle: "ترتیب نمایش", colName: "StatusOrder", showInMobile: true
        }
    ];
    const rowButtons = [
        { title: "مرتب سازی", type: "common", className: "group-Btn-smalll btn-primary", onclick: incOrder, icon: <ArrowDownSquare size={18} className="rowBtn" color="#ff7300" /> },
        { title: "مرتب سازی", type: "common", className: "group-Btn-smalll btn-primary", onclick: decOrder, icon: <ArrowUpSquare size={18} className="rowBtn" color="#007b80" /> },
        {
            title: "حذف وضعیت", type: "delete", className: "group-Btn-smalll btn-danger", onclick: (item) => {
                dispatch(setDialog({
                    status: 'show',
                    arrayBtn: ['yes', 'no'],
                    dialogTitle: 'حذف وضعیت',
                    dialogText: 'آیا از حذف مطمئن هستید؟',
                    okOperation: () => deleteSt(item)
                }))
            }
        }
    ]
    function close() {
        setPopData({
            show: false
        });
        setCurrentStatus(null);
        setPending(false);
    }
    function prepareForAdd() {
        setCurrentStatus({ ID: 0 });
    }
    function prepareForEdit(row) {
        delete row.e;
        setCurrentStatus(row);
    }
    function cancelRow() {
        setCurrentStatus(null);
    }
    function deleteSt(row) {
        if (isPending) {
            return;
        }
        setPending(true);
        const onDelete = (res) => {
            setPending(false);
            if (res.Error) {
                setSubmitError(res.Error);
            }
            else if (res !== "PENDING") {
                statusList.Data = statusList.Data.filter(s => Number(s.ID) !== Number(row.ID));
                setStatusList({ ...statusList });
            }
        }
        deleteStatus(row.ID, onDelete);
    }
    function onSubmit() {
        if (isPending) {
            return;
        }
        setPending(true);
        const onAddEdit = (res) => {
            setPending(false);
            if (res.Error) {
                setSubmitError(res.Error);
            }
            else if (res !== "PENDING") {
                if (Number(currentStatus.ID) > 0) {
                    const found = statusList.Data.find(s => Number(s.ID) === Number(currentStatus.ID));
                    found.StatusTitle = currentStatus.StatusTitle;
                }
                else {
                    const statusOrder = statusList.Data.map(s => Number(s.StatusOrder)).reduce((a, b) => Math.max(a, b), 0);
                    statusList.Data.push({ ...currentStatus, StatusOrder: statusOrder + 1, ID: Number(res.Data) });
                }
                setCurrentStatus(null);
            }
        }
        addEditStatus(currentStatus, onAddEdit);
    }
    function onInputKeyDown(e) {
        if (e.key.toLowerCase() === "enter") {
            onSubmit();
        }
    }
    function decOrder(row) {
        setShowReorderBtn(true);
        const stList = statusList.Data.sort((c, d) => Number(d.StatusOrder) - Number(c.StatusOrder));
        const found = stList.find(s => Number(s.ID) === Number(row.ID));
        for (let i = 0; i < stList.length; i++) {
            const r = stList[i];
            if (Number(r.StatusOrder) < Number(found.StatusOrder)) {
                const order = found.StatusOrder;
                found.StatusOrder = Number(r.StatusOrder);
                r.StatusOrder = Number(order);
                const newStatusList = stList.sort((a, b) => Number(a.StatusOrder) - Number(b.StatusOrder))
                setStatusList({ Data: newStatusList });
                break;

            }
        }
    }
    function incOrder(row) {
        setShowReorderBtn(true);
        const found = statusList.Data.find(s => Number(s.ID) === Number(row.ID));
        for (let i = 0; i < statusList.Data.length; i++) {
            const r = statusList.Data[i];
            if (Number(r.StatusOrder) > Number(found.StatusOrder)) {
                const order = found.StatusOrder;
                found.StatusOrder = Number(r.StatusOrder);
                r.StatusOrder = Number(order);
                const newStatusList = statusList.Data.sort((a, b) => Number(a.StatusOrder) - Number(b.StatusOrder))
                setStatusList({ Data: newStatusList });
                break;

            }
        }
    }
    function submitReorder() {
        if(isPending)
        {
            return;
        }
        setPending(true);
        const onReorder = (res) => {
            setPending(false);
            if (res.Error) {
                setSubmitError(res.Error);
            }
            else if (res !== "PENDING") {
                setShowReorderBtn(false);
            }
        }
        const orderList ={};
        statusList.Data.forEach(s=> orderList[s.ID] = s.StatusOrder);
        reorderStatusList(orderList, onReorder);
    }
    function cancelReorder()
    {
        getStatusList(setStatusList);
        setShowReorderBtn(false);
    }
    useEffect(() => {
        if (show) {
            getStatusList(setStatusList);
        }
    }, [show]);
    return (
        <Modal show={show} onHide={() => { }}>
            <Modal.Header className="headerStyle">
                <span>
                    <FontAwesomeIcon icon={faThList} size="lg" />&nbsp;
                    مدیریت وضعیت ها
                </span>
                <FontAwesomeIcon icon={faTimes} size="lg" onClick={close} />
            </Modal.Header>
            <Modal.Body className="bodyStyle">
                {submitError &&
                    <Alert variant="danger">
                        <FontAwesomeIcon icon={faExclamationTriangle} size="lg" />&nbsp;
                        {submitError}
                        <FontAwesomeIcon icon={faTimes} size="lg" style={{ float: "left" }} onClick={() => setSubmitError(null)} />
                    </Alert>
                }
                {currentStatus &&
                    <Row className="rowBorder mt-1 mb-1" style={{ margin: 0, paddingTop: "8px", paddingBottom: "8px" }}>
                        <Col md={8} style={{ paddingLeft: 0 }}>
                            <FormControl placeholder="عنوان وضعیت" className="tableRowInput" onChange={e => currentStatus.StatusTitle = e.target.value}
                                onKeyDown={onInputKeyDown} defaultValue={currentStatus.StatusTitle} />
                        </Col>
                        <Col md={4} style={{ paddingRight: 0 }}>
                            <Button className="group-Btn-smalll" variant="success" disabled={isPending}><CheckLg size={16} onClick={onSubmit} /></Button>
                            <Button className="group-Btn-smalll" variant="danger" onClick={cancelRow} disabled={isPending}><DashCircle size={17} /></Button>
                        </Col>
                    </Row>
                }
                {!showReorderBtn && !currentStatus &&
                    <Row className="mt-1" style={{ margin: 0 }}>
                        <Button variant="light" className="hoverIcon" onClick={prepareForAdd}
                            style={{ borderBottom: "1px solid white", borderRadius: ".25rem .25rem 0 0", backgroundColor: "#526ebc", color: "white" }}><PlusCircle size={20} /></Button>
                    </Row>
                }
                {
                    showReorderBtn &&
                    <div className="mb-1">
                        <Button variant="info" className="group-Btn-smalll" onClick={submitReorder} disabled={isPending}><ArrowRepeat size={18}/>&nbsp;مرتب سازی</Button>
                        <Button variant="danger" className="group-Btn-smalll" onClick={cancelReorder} disabled={isPending}><DashCircle size={18}/>&nbsp;انصراف</Button>
                    </div>
                }

                <BihamtaTable className="mt-0" columns={tableCols} rowButtons={rowButtons} rowClick={prepareForEdit} dataList={statusList} maxHeight={500} />
            </Modal.Body>
        </Modal>
    )
}